import Attendee from "./Attendee";
import Event from "./Event";
import OrderStatus from "./OrderStats";

class Order {
    orderId;
    event_id;
    mainEmail;
    attendees;
    total;
    state;
    city;
    decanato;
    periodYear;
    periodQuincena;
    loadNotes;
    decanatoAttachment;
    status;
    paypalId;
    paypalStatus;
    event;

    constructor(detail = {id: null, event_id: null, mainEmail: null, attendees: [], total: null, state: null, city: null, status: OrderStatus.IN_PROCESS}) {
        // this._id = detail.id;
        this.event_id = detail.event_id;
        this.mainEmail = detail.mainEmail;
        this.attendees = detail.attendees;
        this.total = detail.total;
        this.status = detail.status;
        this.state = null;
        this.city = null;
        this.decanato = null;
        this.periodYear = new Date().getFullYear();
        this.periodQuincena = 1;
        this.loadNotes = '';
        this.decanatoAttachment = null;
        this.paypalId = null;
    }

    static fromJson(json) {
        let order = new Order();
        order.orderId = json.orderId ?? null;
        order.event_id = json.event_id ?? null;
        order.mainEmail = json.mainEmail ?? null;
        order.attendees = json.attendees ? json.attendees.map(at => Attendee.fromJSON(at)) : [];
        order.total = json.total ?? '0.0';
        order.state = json.state ?? "";
        order.city = json.city ?? "";
        order.decanato = json.decanato ?? "";
        order.periodYear = json.periodYear ?? json.period_year ?? new Date().getFullYear();
        order.periodQuincena = json.periodQuincena ?? json.period_quincena ?? 1;
        order.loadNotes = json.loadNotes ?? json.notes ?? '';
        order.status = json.status ?? OrderStatus.IN_PROCESS;
        if(json.paypalId){
            order.paypalId = json.paypalId;
        } else if(json.paypal_id) {
            order.paypalId = json.paypal_id;
        }else {
            order.paypalId = null;
        }
        order.paypalStatus = json.paypal_status ?? null;
        order.event = json.event ? Event.fromJSON(json.event) : new Event();
        return order;
    }
}

export default Order;